module.exports = __webpack_public_path__ + "static/media/non-disclusure-blue.77cb9516.svg";